import { createAction } from '@reduxjs/toolkit';
import { SHOW_RIGHT_DRAWER, HIDE_RIGHT_DRAWER } from '../actionConstants';

export const showRightDrawer = createAction(SHOW_RIGHT_DRAWER);
export const hideRightDrawer = createAction(HIDE_RIGHT_DRAWER);
